/* What people click on the way to a booking (10.10, the owner: «gjøre det enkelt i kode å følge slike trender og hva folk
   trykker på»). One listener for the whole page, no change to any button. Every event carries the theme's name, so the
   old theme and a new one can be compared side by side in GA4 (Utforsk > Trakt).

   Booking path (the Servicify window, in any theme):
     ll_booking_open      «Velg en tid» (or the sticky Book bar) opened the booking window; placement direct = opened by
                          itself on a page reached with ?book=1 (from consult_button|list_book|link, laserlab-booking.js;
                          only while a switch that adds ?book=1 is on, DIRECT_LINKS there: all off on live 11.10)
     ll_booking_day       the day step (first per window): day=chosen for a tapped day (or one picked with the keyboard);
                          day=preselected when a time is chosen without a tapped day, on the day laserlab-booking.js picked
                          in code (the first free day on opening, or after «Neste måned»), sent just before ll_booking_time.
                          A theme that sends it without day (kombo v1, CLEAN) counts tapped days only: compare it with
                          day=chosen
     ll_booking_time      a time was chosen (first per window)
     ll_booking_details   the name/e-mail step appeared
     ll_booking_submit    the confirm button in that step was pressed
     ll_booking_phone_help  the booking window showed the phone number (improvement telefonhjelp_i_booking):
                          reason no_slots (a day without times), times_shown (the line under the times; shown from the
                          start since 11.10, so about once per window with free times) or three_days (12.10: the third
                          other day looked at while that line shows, no time chosen; before 12.10 it came only when the
                          line was drawn anew, so 11.10-12.10 has almost none). Each reason once per window
     (the confirmed booking itself: booking_confirmed on /pages/takk, once per booking, laserlab-booking-tracking.js; the
     page view there is the Google app's own)
   Around it:
     ll_consultation_click   a link or button to a consultation (Gratis konsultasjon, Skinlab); placement consult_band
                             is the band over the footer, footer|header|catbar|drawer the site frame, product|page the rest
     ll_book_time_click      «Book time» in the header or the menu
     ll_nav_click            header menu, phone category bar, menu drawer, footer and in-page category choices
                             (area = header|catbar|drawer|footer|shop_category|treatment_category).
                             From the category bar also scroll_y: how far down the page it was tapped, rounded to 100 px
                             and capped at 5000 (11.10, so data shows whether the line is used deep in a page before it
                             stops being pinned, improvement rolig_kategorilinje)
     ll_list_book_click      «Book» on a treatment card in a list
     ll_need_filter          a skin-need chip or picker choice on a treatment list, or in the Shop's row; page_path tells them
                             apart; selected = the tap chose the need (false = it removed it). With the Shop as a
                             store (improvement butikk, 11.10) also placement: row (an «Etter <behandling>» row) or
                             sheet (a need in the Filter sheet; the row then holds product types). In the plain Shop
                             with butikk on the row holds types (ll_type_filter), so row comes only from «Etter» pages.
                             The compact picker emits one event per changed choice; need=all, selected=false clears it.
     ll_type_filter          butikk (11.10): a product type chosen or removed (type = rens|toner|serum|krem|...,
                             selected, placement row|sheet)
     ll_shop_sort            butikk (11.10): an order chosen in the Shop row's Sorter (sort = bestselling|newest|
                             price-ascending|price-descending|name, placement row)
     ll_list_search          the first letter typed in a list's own search (treatment lists and the Shop), once per
                             page view (11.10, so the use of that search is known before anyone removes it). Not sent
                             on live 11.10: rolig_filterrad took the search off the treatment lists and butikk off the
                             Shop (no [data-filter-input] on any list)
     ll_phone_click          any phone link (tel:); placement booking (in the booking window), footer, page, or the
                             link's own data-ll-placement (timebestilling). Sent in addition to the events above, so
                             their counts stay comparable with the old theme
     data-ll-event           any other link that names its own event (ll_google_reviews_click on the Google line, only
                             with google_snitt on: off on live 11.10); placement = its data-ll-placement or where it sits
     ll_home_hero_click      the home hero, through data-ll-event: placement split with delt_forside on (live 11.10),
                             overlay with it off
   ll_booking_open from the Book bar has placement sticky_start while the bar shows from the start (book_linje_fra_start,
   off on live 11.10, so today the bar gives sticky only).

   ll_flags (12.10): GA4 keeps only the first 100 characters of a parameter, and the readable list of switches passed that
   with 13 on (171 characters). GA4 therefore gets a fixed short code per switch (FLAG_CODES below, in the order of
   <body data-ll-flags>, e.g. «tb rf rs rh»); Shopify's customer events keep the readable list. In GA4 compare one switch
   with «matches regex» (^| )mk( |$) on the ll_flags dimension. «ingen» = no switch on. If the complete code list exceeds
   100 characters, whole remaining codes go to ll_flags_extra (and numbered extra parameters if later needed), each
   limited to 100 characters. Include those dimensions when comparing a switch beyond the first parameter.

   Shop (10.10):
     ll_add_to_cart       a «Legg i handlekurv» / «Legg til» / + was pressed: placement page (the product page's own
                          button), sticky (the cart bar at the bottom on phones), sticky_start (that bar while it shows
                          from the first screen, improvement kurv_linje_fra_start, off on live 11.10), card (+ on a
                          product card), upsell
                          (Kompletter kjøpet, Prøv en annen smak); item_id = the variant
     ll_checkout_click    «Til kassen»: placement drawer or cart (the /cart page); cart_express = Shop Pay / Google Pay /
                          Apple Pay under it on /cart
   The cart bar's button is not a booking: it never counts as ll_booking_open.

   Privacy: GA4 gets the events only with the visitor's analytics consent (Shopify's banner), no page view of its own
   (Shopify's Google app already counts pages) and no personal data: only the page path, the treatment's handle and the
   label of what was clicked. Servicify adds its own «Calendar Opened», «Date Selected» and «Timeslot Selected» («Date
   Selected» only for a day the visitor picks: laserlab-booking.js holds it back for the days it picks in code, 12.10).
   The same events go to Shopify's customer events (Shopify.analytics.publish), where each pixel applies its own consent. */
(() => {
  if (window.LaserlabFunnel) return;
  window.LaserlabFunnel = true;

  const MEASUREMENT_ID = 'G-3LZ4W8GF84';
  const PORTAL = '.servicify-modal-portal';
  const OPEN_TRIGGER = '.servicify-select-a-time-button, .servicify-popup-calendar-button, [data-sticky-book-button]';
  const CONSULT = 'a[href*="/products/gratis-konsultasjon"], a[href*="/products/skinlab-konsultasjon"], a[href*="view=konsultasjon"], .ll-consult-button, .ll-consult-band__button, [id^="GratisKonsultasjon-"], [id^="SkinlabKonsultasjon-"]';
  const BOOK_TIME = '.book-now-button, .ll-nav-mobile-book';
  const theme = (window.Shopify && window.Shopify.theme && window.Shopify.theme.name) || '';
  // One code per key of snippets/laserlab-flags.liquid (35 keys; all on = 100 characters + h in ll_flags_extra).
  // Existing two-letter codes remain stable. Every new switch gets a unique code
  // here; a key without one is sent to GA4 as it is.
  const FLAG_CODES = {
    telefonhjelp_i_booking: 'tb', konsultasjon_direkte: 'kd', kort_book_direkte: 'kb', avbestilling_ved_knappen: 'ab',
    google_snitt: 'gs', konsultasjon_linje: 'kl', book_linje_fra_start: 'bl', faste_svar: 'fs', kort_intro_forst: 'ki',
    uten_utforsk: 'uu', rynke_pris: 'rp', kurv_linje_fra_start: 'kv', rolig_filterrad: 'rf', rolig_shop: 'rs',
    rolig_hover: 'rh', ryddig_side: 'ry', lister_rader: 'lr', rolig_kategorilinje: 'rk', delt_forside: 'df',
    utforsk_rolig: 'ur', fakta_boks: 'fb', mobilkant: 'mk', butikk: 'bu', samlet_tekst: 'st', protokoll: 'pr',
    finn_veien: 'fv', konsultasjon_tydelig: 'kt', besok_oss: 'bo', skinlab_uten_epost: 'se', rolig_footer: 'rr', kort_stillbilde_mobil: 'sm', booking_tillegg: 'bt', shop_kjop: 'sk', novojet_etiketter: 'n', hair_taupe: 'h',
  };
  const gaFlags = (flags) => {
    const chunks = [''];
    flags.split(/\s+/).filter(Boolean).map((key) => FLAG_CODES[key] || key).forEach((code) => {
      const index = chunks.length - 1;
      const next = [chunks[index], code].filter(Boolean).join(' ');
      if (next.length <= 100) chunks[index] = next;
      else chunks.push(code);
    });
    const params = { ll_flags: chunks[0] || 'ingen' };
    chunks.slice(1).forEach((chunk, index) => {
      params[index ? `ll_flags_extra_${index + 1}` : 'll_flags_extra'] = chunk;
    });
    return params;
  };
  let flow = null;

  function allowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
    } catch (error) { return false; }
  }

  function label(el) {
    const text = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
    return text.slice(0, 60);
  }

  function product() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function send(name, params) {
    // ll_flags: the improvements switched on in the theme (snippets/laserlab-flags), so each one can be compared alone:
    // the readable list to Shopify's customer events, the short codes to GA4 (see the header).
    const flags = (document.body && document.body.dataset.llFlags) || '';
    const data = Object.assign({ ll_theme: theme, ll_flags: flags || 'ingen', page_path: window.location.pathname, treatment: product() }, params || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) { /* customer events are optional */ }
    // GA4 itself is set up by Shopify's Google app on the same page (its page views use the same gtag); the events
    // only name it as their destination and leave its settings alone.
    if (!allowed() || typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', name, Object.assign({ send_to: MEASUREMENT_ID }, data, gaFlags(flags)));
    } catch (error) { /* measurement never blocks the page */ }
  }

  function area(el) {
    if (el.closest('.ll-catbar')) return 'catbar';
    if (el.closest('#MenuDrawer, menu-drawer')) return 'drawer';
    if (el.closest('.ll-consult-band')) return 'consult_band';
    if (el.closest('footer, .footer, #LaserlabFooter')) return 'footer';
    if (el.closest('header, .header')) return 'header';
    return '';
  }

  // One booking window = one flow; each step counts once per window.
  function step(name, params) {
    if (!flow) flow = { steps: {} };
    if (flow.steps[name]) return;
    flow.steps[name] = true;
    send(name, params);
  }

  // Some themes load Shopify's consent API only when the banner needs it; load it so the consent check can answer.
  try {
    const shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    }
  } catch (error) { /* without the API nothing is sent to GA4 */ }

  // The name/e-mail step is rendered by the app after a time is chosen: count it when an e-mail field appears. The
  // watcher only runs while a booking window is in use (from the opening click, at most 15 minutes).
  let watcher = null;
  let watchUntil = 0;
  function watchDetails() {
    watchUntil = Date.now() + 15 * 60 * 1000;
    if (watcher) return;
    watcher = new MutationObserver(() => {
      if (Date.now() > watchUntil || (flow && flow.steps.ll_booking_details)) {
        watcher.disconnect();
        watcher = null;
        return;
      }
      if (document.querySelector(`${PORTAL} input[type="email"]`)) step('ll_booking_details');
    });
    watcher.observe(document.body, { childList: true, subtree: true });
  }

  // A page reached with ?book=1 opens its time picker in code (laserlab-booking.js): the same as an opening click.
  document.addEventListener('ll:booking-autoopen', (event) => {
    flow = { steps: {} };
    watchDetails();
    send('ll_booking_open', { placement: 'direct', from: (event.detail && event.detail.from) || 'link' });
  });

  document.addEventListener('ll:booking-phone-help', (event) => {
    const reason = event.detail && event.detail.reason;
    if (reason === 'no_slots' || reason === 'three_days' || reason === 'times_shown') send('ll_booking_phone_help', { reason });
  });

  // On window, not document: laserlab-booking.js loads first and stops a tap on the «Velg en tid» placeholder at document
  // (stopImmediatePropagation), so a document listener here would never see it.
  window.addEventListener('click', (event) => {
    // Only the visitor's own clicks: the sticky Book bar and the queued «Velg en tid» click the real button in code.
    if (!event.isTrusted) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const inPortal = target.closest(PORTAL);
    const phone = target.closest('a[href^="tel:"]');
    if (phone) {
      send('ll_phone_click', { placement: phone.dataset.llPlacement || (inPortal ? 'booking' : area(phone) === 'footer' ? 'footer' : 'page') });
      // In the booking window the phone line sits among the times: never count it as a time.
      if (inPortal) return;
    }
    const tagged = !inPortal && !phone && target.closest('[data-ll-event]');
    if (tagged && /^ll_[a-z_]+$/.test(tagged.dataset.llEvent || '')) {
      send(tagged.dataset.llEvent, { placement: tagged.dataset.llPlacement || area(tagged) || 'page', link_url: tagged.getAttribute('href') || '' });
      return;
    }
    if (inPortal) {
      if (target.closest('.DayPicker-Day[aria-disabled="false"]')) step('ll_booking_day', { day: 'chosen' });
      else if (target.closest('[data-ll-slot], .servicify-slots-scroll > *')) {
        // No day tapped: laserlab-booking.js picked it in code (on opening, or after «Neste måned»), so the time counts it.
        if (!flow || !flow.steps.ll_booking_day) step('ll_booking_day', { day: 'preselected' });
        step('ll_booking_time');
      } else if (inPortal.querySelector('input[type="email"]') && target.closest('button[type="submit"], .Servicify-NoCheckout-Modal button[data-servicify]')) step('ll_booking_submit');
      return;
    }

    // Shop: a product into the cart. The cart bar forwards its tap to the page's own button in code (not trusted, so
    // it is counted once, here, as the bar).
    const cartBar = target.closest('laserlab-sticky-book[data-mode="cart"]');
    const add = cartBar ? cartBar.querySelector('[data-sticky-book-button]') : target.closest('button[name="add"]');
    if (add && (!cartBar || target.closest('[data-sticky-book-button]'))) {
      if (add.disabled || add.getAttribute('aria-disabled') === 'true') return;
      // A treatment's «Velg en tid» before the booking app has drawn its own button: the same form button, queued for
      // the booking (laserlab-booking.js replays it in code, so it is counted once, here). Never a cart add.
      if (add.hasAttribute('data-ll-booking-placeholder')) {
        // A second tap while the first still waits for the app (data-ll-queued) is the same opening.
        if (add.hasAttribute('data-ll-queued')) return;
        flow = { steps: {} };
        watchDetails();
        send('ll_booking_open', { placement: 'page' });
        return;
      }
      const variant = cartBar ? document.querySelector('.product__block--buy_buttons form[action*="/cart/add"] [name="id"]') : add.form && add.form.querySelector('[name="id"]');
      const placement = cartBar ? (cartBar.hasAttribute('data-early') ? 'sticky_start' : 'sticky')
        : add.closest('laserlab-upsell, .ll-upsell') ? 'upsell'
        : add.closest('.product-card, .card-product') ? 'card'
        : 'page';
      send('ll_add_to_cart', { placement, item_id: variant ? String(variant.value || '') : '' });
      return;
    }
    if (cartBar) return;
    const checkout = target.closest('[name="checkout"]');
    if (checkout) {
      send('ll_checkout_click', { placement: checkout.closest('#CartDrawer, cart-drawer') ? 'drawer' : 'cart' });
      return;
    }
    // Shop Pay / Google Pay / Apple Pay under «Til kassen» (content_for_additional_checkout_buttons): the tap reaches
    // the page on the wallet's own element (shop-pay-wallet-button, shopify-google-pay-button, ...). Testing that tag
    // leaves out a tap in the gap between the buttons, which starts no checkout.
    if (target.closest('.additional-checkout-buttons') && /-button$/i.test(target.tagName)) {
      send('ll_checkout_click', { placement: target.closest('#CartDrawer, cart-drawer') ? 'drawer_express' : 'cart_express' });
      return;
    }

    const opener = target.closest(OPEN_TRIGGER);
    if (opener) {
      flow = { steps: {} };
      watchDetails();
      const sticky = opener.matches('[data-sticky-book-button]');
      send('ll_booking_open', { placement: sticky ? (opener.closest('[data-early]') ? 'sticky_start' : 'sticky') : 'page' });
      return;
    }

    const consult = target.closest(CONSULT);
    if (consult) {
      send('ll_consultation_click', {
        placement: consult.dataset.llPlacement || (consult.closest('.llhp-start') ? 'home' : area(consult)) || (consult.closest('.product__info-wrapper, product-info') ? 'product' : 'page'),
        link_text: label(consult) || 'Gratis konsultasjon'
      });
      return;
    }

    const bookTime = target.closest(BOOK_TIME);
    if (bookTime) {
      send('ll_book_time_click', { placement: area(bookTime) });
      return;
    }

    const needChoice = target.closest('[data-filter-need-choice]');
    if (needChoice) {
      // Window capture runs before the component updates aria-pressed. Re-selecting the current need changes nothing.
      if (needChoice.disabled || needChoice.getAttribute('aria-pressed') === 'true') return;
      const need = needChoice.dataset.filterNeedChoice || '';
      send('ll_need_filter', { need: need || 'all', selected: Boolean(need) });
      return;
    }
    const category = target.closest('[data-shop-category-chip], [data-filter-directory] [data-filter-type-chip]');
    if (category) {
      if (category.disabled) return;
      const shop = category.hasAttribute('data-shop-category-chip');
      const params = { area: shop ? 'shop_category' : 'treatment_category', category: category.getAttribute(shop ? 'data-shop-category-chip' : 'data-filter-type-chip'), link_text: label(category) };
      if (category.hasAttribute('href')) params.link_url = category.getAttribute('href');
      send('ll_nav_click', params);
      return;
    }

    // Shop as a store (butikk, 11.10): a product type in the row or in the Filter sheet.
    const typeChoice = target.closest('[data-shop-type-chip], [data-shop-sheet-type]');
    if (typeChoice) {
      send('ll_type_filter', { type: typeChoice.getAttribute('data-shop-type-chip') || typeChoice.getAttribute('data-shop-sheet-type'), selected: typeChoice.getAttribute('aria-pressed') !== 'true', placement: typeChoice.hasAttribute('data-shop-type-chip') ? 'row' : typeChoice.closest('[data-shop-sidebar]') ? 'sidebar' : 'sheet' });
      return;
    }
    const chip = target.closest('[data-filter-need-chip], [data-shop-need-chip]');
    if (chip) {
      // placement only from a butikk Shop (beside its sheet placement), so the payload elsewhere is as before.
      send('ll_need_filter', Object.assign({ need: chip.getAttribute('data-filter-need-chip') || chip.getAttribute('data-shop-need-chip'), selected: chip.getAttribute('aria-pressed') !== 'true' }, chip.closest('.ll-shop--butikk') ? { placement: 'row' } : {}));
      return;
    }
    // With butikk the needs are chosen in the Filter sheet, so they are counted there; the sheet without it is not
    // counted, as before.
    const sheetNeed = target.closest('[data-shop-sheet-need]');
    if (sheetNeed?.closest('.ll-shop--butikk, .ll-shop-sheet--butikk')) {
      send('ll_need_filter', { need: sheetNeed.getAttribute('data-shop-sheet-need'), selected: sheetNeed.getAttribute('aria-pressed') !== 'true', placement: sheetNeed.closest('[data-shop-sidebar]') ? 'sidebar' : 'sheet' });
      return;
    }

    const link = target.closest('a[href]');
    if (!link) return;
    const where = area(link);
    if (where) {
      const params = { area: where, link_text: label(link), link_url: link.getAttribute('href') };
      // 11.10: where on the page the category bar was tapped (100 px steps, at most 5000), so a pinned line can be
      // compared with one that scrolls away (rolig_kategorilinje).
      if (where === 'catbar') params.scroll_y = Math.min(5000, Math.round(window.scrollY / 100) * 100);
      send('ll_nav_click', params);
      return;
    }
    if (link.matches('.product__card-custom-button') || (/^\s*book\s*$/i.test(link.textContent || '') && link.closest('.product-card, .card-product, [data-filter-card]'))) {
      send('ll_list_book_click', { link_url: link.getAttribute('href') });
    }
  }, true);

  // butikk (11.10): the order chosen in the Shop row's Sorter (the select only sits in the row with the switch on).
  document.addEventListener('change', (event) => {
    // The native picker remains available where the enhanced popover is unsupported. Its genuine change is the
    // sole event owner there; the enhanced buttons update the select value without emitting a synthetic change.
    const needSelect = event.isTrusted && event.target instanceof Element ? event.target.closest('[data-filter-need-select]') : null;
    if (needSelect) {
      send('ll_need_filter', { need: needSelect.value || 'all', selected: Boolean(needSelect.value) });
      return;
    }
    const select = event.target instanceof Element ? event.target.closest('.ll-bk-sort [data-shop-sort]') : null;
    if (select) send('ll_shop_sort', { sort: select.value, placement: 'row' });
  }, true);

  // A list's own search (data-filter-input: the treatment lists and the Shop): the first non-empty input of the page.
  let listSearched = false;
  document.addEventListener('input', (event) => {
    if (listSearched || !event.isTrusted) return;
    const field = event.target instanceof Element ? event.target.closest('[data-filter-input]') : null;
    if (!field || !String(field.value || '').trim()) return;
    listSearched = true;
    send('ll_list_search', {});
  }, true);

  // Keyboard (11.10): Enter/Space on a time becomes a click in code (laserlab-booking.js, not trusted, so the listener
  // above skips it), and on a day the calendar takes the key without any click. Count both from the key itself.
  window.addEventListener('keydown', (event) => {
    if (!event.isTrusted || (event.key !== 'Enter' && event.key !== ' ')) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !target.closest(PORTAL)) return;
    if (target.closest('.DayPicker-Day[aria-disabled="false"]')) step('ll_booking_day', { day: 'chosen' });
    else if (target.matches('[data-ll-slot]')) {
      if (!flow || !flow.steps.ll_booking_day) step('ll_booking_day', { day: 'preselected' });
      step('ll_booking_time');
    }
  }, true);
})();
